export const information = {
    shipto : {
        companyName : '#Company Name',
        streetAddress : '#Street Address',
        city : '#City Name' 
    },
    billTo : {
        companyName : '#Company Name',
        streetAddress : '#Street Address',
        city : '#City Name',
    },
    payment : {
        bankAccount : '#Bank Account',
        bankName :'#Bank Full Name',
        bankCode : '#Bank Code',
    },
    Paypal : {
        paypalAccount : '#email@domain.xxx',
    },
    companyInfo : {
        companyName : '#Company Name',
        streetAddress : '#Street Address and num',
        city : '#City Name , ZIP Code' 
    }
}
export const product = {
    discount : 50,
    productNumber : '98782',
    info : [
        {
            description : 'Logo Design',
            price : 1500,
            qty : 3,
        },
        {
            description : 'Web Site Design',
            price : 980,
            qty : 12,
        },
        {
            description : 'Logo Design',
            price : 199,
            qty : 2,
        },
    ] 
}

// export const dataInvoice = [
//     {
//         label : 'Invoice',
//         value : '565254',
//     },
//     {
//         label : 'Date',
//         value : '01/02/2022',
//     },
//     {
//         label : 'Due Date',
//         value : '30/02/2022',
//     }, 
// ]
// export const location = [
//     '#Main Road',
//     '#Building Name',
//     '#Country',
// ]
// export const paymentInfo=[
//     {
//         label : 'Account',
//         value : '000 0000 000',
//     },
//     {
//         label : 'A/C NAME',
//         value : '000 0000 000',
//     },
//     {
//         label : 'BANK DETAILS',
//         value : 'Your Account',
//     }, 
// ]

// export const connections = {
//     connection : {
//         number : '000 000 000',
//         email : 'www.facebook.com',
//         address : 'your street addres here',
//     }
// }

// export const companyInfo = {
//     info :{
//         managerName : '#Manager Name',
//         customerName : '#Customer Name',
//         productName : '#Product Name',
//     }
// }
